<template>
    <div :class=" loaderFullContainer ? 'h-full' : 'loader'">
        <div class="flex pt-2 items-center justify-center h-full">
            <div class="spinner-grow text-gray-600" role="status">
                <span class="sr-only">{{ message }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: 'Loading...',
        },
        loaderFullContainer: {
            type: Boolean,
            default: false,
        }
    },
};
</script>
